<template>
  <div>
    <div class="d-flex bd-b mg-b-10">
      <label class="tx-sans tx-11 tx-semibold tx-uppercase tx-color-01 tx-spacing-1">Сургалт хайх</label>
    </div>
    <DatePicker
      style="width: 100%"
      v-model="filterParams.date"
      type="monthrange"
      range-separator="-"
      start-placeholder="Эхлэх"
      end-placeholder="Дуусах"
    ></DatePicker>

    <label class="tx-sans tx-11 tx-uppercase tx-color-01 tx-spacing-1 mg-t-20"
      >Сургалтын төрөл</label
    >
    <loc-type-cascader
      v-model="filterParams.type"
      :id="parseInt(filterParams.type, 10)"
      locTypekey="courseType"
      disableAdd
      class="wd-100p-f"
    />
    <label class="tx-sans tx-11 tx-uppercase tx-color-01 tx-spacing-1 mg-t-20"
      >Сургалтын нэр</label
    >
    <Input v-model="filterParams.name" placeholder="Хайх нэрээ бичнэ үү" />
    <!-- <template v-if="filterParams.activeId==1">
        <label class="tx-sans tx-11 tx-uppercase tx-color-01 tx-spacing-1 mg-t-20">Элссэн сургалтыг харуулах?</label>
        <Select v-model="filterParams.joinOption" class="wd-100p">
            <Option :value="0" label="Харуулна"></Option>
            <Option :value="1" label="Харуулахгүй"></Option>
        </Select>
    </template> -->

    <div class="btn-group wd-100p mg-t-10">
      <button
        @click="$emit('on-search', filterParams)"
        class="btn btn-xs btn-uppercase btn-brand-01 wd-50p"
      >
        Хайх
      </button>
      <button
        @click="$emit('on-reset')"
        class="btn btn-xs btn-uppercase btn-light wd-50p"
      >
        Бүгд
      </button>
    </div>
  </div>
</template>

<script>
import { DatePicker, Input, Select, Option } from "element-ui";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    DatePicker,
    Input,
    Select,
    Option,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    filterParams: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
